<style>
</style>

<template>
  <v-container fluid class="pa-0" id="basket--view">
    <v-row class="secondary">
      <v-container fluid style="max-width: 960px;">
        <v-row class="mt-0">
          <v-col cols="12">
            <div class="headline primary--text">{{ $t('Nákupní košík') }}</div>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <div v-show="hasItems">
      <v-container fluid class="px-0 py-0 mt-8" style="max-width: 960px;">
        <basket-table></basket-table>
      </v-container>
    </div>
<!--    <v-row class="background: grey lighten-1">-->
<!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
<!--        <v-alert type="info" color="grey lighten-1">{{ $t('Zde můžete upravit svůj nákupní košík, pokračovat nebo dokončit nákup.') }}-->
<!--        </v-alert>-->
<!--      </v-container>-->
<!--    </v-row>-->
  </v-container>
</template>
<script>
    import BasketMixin from '@/mixins/basket-mixin.js'
    import CustomerMixin from '@/mixins/customer-mixin.js'
    import StorageMixin from '@/mixins/storage-mixin.js'
    import BasketTable from '@/components/basket-table.vue'

    export default {
        name: 'BasketPage',
        components: {
            'basket-table': BasketTable
        },
        mixins: [CustomerMixin, BasketMixin, StorageMixin],
        watch: {
            hasItems(value) {
                if (!value) {
                    this.$router.push({
                        name: !this.isRegistered ? 'eshop' : 'reservations'
                    }).catch(console.log)
                }
            }
        }
    }
</script>
